import script from "./ViewStaffProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewStaffProfile.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__